import { render } from "./BetRecord.vue?vue&type=template&id=889c85e0&scoped=true"
import script from "./BetRecord.vue?vue&type=script&lang=js"
export * from "./BetRecord.vue?vue&type=script&lang=js"

import "./BetRecord.vue?vue&type=style&index=0&id=889c85e0&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889c85e0"]])

export default __exports__